const COOKIE_KEYS = {
  GA: '_ga',
  ADS: '_10life_ads',
  LGMADS: '_10life_lgmads',
  UTM_VISUAL: '_10life_utmVisual',
  GCLID: '_10life_gclid',
};

export default {
  
  data() {
    if (!process.env.MIDDLE_PLATFORM_URL) {
      throw new Error('MIDDLE_PLATFORM_URL is not defined in environment variables.');
    }
    return {
      middlePlatformAdTrackingUrl: `${process.env.MIDDLE_PLATFORM_URL}/integration/ad-tracking/hash`,  
      middlePlatformLGMTrackingUrl: `${process.env.MIDDLE_PLATFORM_URL}/integration/lead-conversion-tracking/hash`,  
    };
  },
  mounted() {
    //
  },
  methods: {
    async getLGMTrackingHash(lgmParams) {
      const data = this.buildLGMTrackingData(lgmParams);
      try {
        const response = await this.$axios.post(this.middlePlatformLGMTrackingUrl, data);
        return response.data.hash;
      } catch (error) {
        console.error('Axios error:', error.response || error.message);
        this.$sentry.captureException(error);
      }
    },
    buildLGMTrackingData(lgmParams) {
      const uid = this.getUid();
      const adsId = this.getAdsId();
      const lgmadsId = this.getLgmadsId();
      const utmVisual = this.getUtmVisual();
      const gclid = this.$cookies.get('_10life_gclid');
      return {
        type: lgmParams?.type || '',
        atk_id: adsId || undefined,
        up_id: uid,
        xr_id: lgmParams?.xr_id || undefined,
        apm: lgmadsId || undefined,
        epg: lgmParams.epg || undefined,
        dpg: lgmParams.dpg || undefined,
        uvs: utmVisual || undefined,
        lm: lgmParams.lgmMeta || undefined,
        ir: lgmParams?.ir || undefined,
        gclid: gclid || undefined,
      };
    },
    getUid() {
      const gaID = this.$cookies.get(COOKIE_KEYS.GA);
      if (!gaID) {
        console.error('Google Analytics ID (_ga) cookie is missing.');
        return null;
      }
      try {
        const match = gaID.match(/.*\.[\d]\.(\d+\.\d+)$/);
        return match ? match[1] : null;
      } catch (error) {
        console.error('Error parsing Google Analytics ID (_ga):', error);
        this.$sentry.captureException(error);
        return null;
      }
    },
    getAdsId() {
      return this.$cookies.get(COOKIE_KEYS.ADS);
    },
    getLgmadsId() {
      return this.$cookies.get(COOKIE_KEYS.LGMADS);
    },
    getUtmVisual() {
      return this.$cookies.get(COOKIE_KEYS.UTM_VISUAL);
    },
  },
}